import { MAX_KEYSET_SIMULATION_OUTPUT_IDS } from "../utils/conversationsProjectFilter"

interface ProjectFilterTruncationBannerProps {
  /** Restricted conversation count before the request cap dropped some; null when nothing was dropped. */
  truncatedFromCount: number | null
  /** Whether a visualizer cluster narrows the project filter. */
  hasClusterFilter: boolean
}

export function ProjectFilterTruncationBanner({
  truncatedFromCount,
  hasClusterFilter,
}: ProjectFilterTruncationBannerProps) {
  if (truncatedFromCount === null) {
    return null
  }

  return (
    <div className="table-pad border-b border-coval-warning-border bg-coval-warning-surface text-sm text-coval-warning-on-surface">
      {hasClusterFilter
        ? "The selected projects and cluster share"
        : "The selected projects hold"}{" "}
      {truncatedFromCount.toLocaleString()} conversations. Only the{" "}
      {MAX_KEYSET_SIMULATION_OUTPUT_IDS.toLocaleString()} most recently added to
      a project are shown.
    </div>
  )
}
